var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sdz-modal",
    {
      ref: "sdzModal",
      attrs: {
        title: _vm.title,
        "confirm-button-label": "ok, entendi",
        "confirmation-event": "onConfirm",
        width: "550",
        "hide-cancel-button": "",
        persistent: "",
        "buttons-position": "right",
        "close-icon": "",
      },
      on: { close: _vm.close, onConfirm: _vm.onConfirm },
    },
    [
      _c("div", { staticClass: "sales-information" }, [
        _c("div", [
          _c("p", [
            _vm._v(
              "\n        Os dados de vendas exibidos nesta tela ainda não foram validados pelo parceiro gestor da campanha e, portanto, não estão finalizados.\n        Para que os dados sejam considerados válidos e oficiais, é necessário que passem pelas seguintes etapas de aprovação:\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("ol", [
            _c("li", [
              _vm._v(
                "Validação do Responsável Legal: A equipe interna do canal revisará os dados para garantir sua precisão e completude."
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Validação da Indústria: Os dados serão enviados para a indústria para validação e confirmação."
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", [
            _vm._v(
              "\n        Durante o processo de aprovação, os dados podem estar sujeitos a alterações. "
            ),
            _c("br"),
            _vm._v("Recomendamos que você:\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("ul", [
            _c("li", [
              _vm._v("Não utilize esses dados como base para decisões finais."),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Aguarde a aprovação final antes de compartilhar esses dados com terceiros."
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Verifique esta tela novamente após a conclusão do processo de aprovação para obter os dados finais."
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }